import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, isDevMode } from '@angular/core';
import { Observable, throwError, map } from 'rxjs';
import { CruiseWrapper } from 'src/app/core/classes/cruise-wrapper';
import { PurchaseRequestStatus } from 'src/app/core/enums/purchase-request-status';
import { environment } from '../../../environments/environment';
import { Purchase, PaymentMethod } from '../../core/models/purchase';
import { Company } from '../../core/models/company';
import { CabinaItinerarioMenorWrapper } from '../../core/classes/cabina-itinerario-menor-wrapper';
import { PurchaseAirTicketDetail } from '../../core/models/purchase/purchase-air-ticket-detail';
import { PurchaseCabinPassenger } from '../../core/models/purchase/purchase-cabin-passenger';
import { PromoService } from './promo.service';
import { CompanyParamsService } from '../../core/services/company-params.service';
import { Cruise } from '../../core/models/cruise';
import { PurchasePayment } from '../../core/models/purchase/purchase-payment';
import { PaymentType } from '../../core/models/purchase/payment-type.enum';
import { PurchasePassengerInformation } from '../../core/models/purchase/purchase-passenger-information';
import { PurchaseContactPerson } from '../../core/models/purchase/purchase-contact-person';
import { PurchaseCabin } from '../../core/models/purchase/purchase-cabin';
import { BlockDeparture } from '../../core/models/purchase/block-departure';
import { UnblockDeparture } from '../../core/models/purchase/unblock-departure';
import { TipoPaqueteEcommerceEnum } from '../../core/enums/type-package-ecommerce.enum';
import { PaypalPaymentItem } from '../../core/models/paypal-payment-item';
import { PurchaseAirTicket } from '../../core/models/purchase/purchase-air-ticket';
import { BookingConfirmationResponse } from '../../core/models/purchase/booking-confirmation-response';
import { PromoCode } from '../../core/enums/promo-code.enum';
import { AirTicketService } from './air-ticket.service';
import { HttpRequestService } from './http-request.service';
import { CabinOrdinalNamePipe } from '../pipes/cabin-ordinal-name.pipe';
import { CruiseServiceAux } from '../../modules/searcher/services/cruise.service';
import { PaypalPaymentItemApi } from '../../core/models/paypal-payment-item-api';
import { NgWebflowService } from 'webflow-lib';
import { StatusRequest } from '../../core/enums/status-request.enum';
import { NamesRequestServicesEnum } from 'src/app/core/enums/names-request-services.enum';

@Injectable({
  providedIn: 'root',
})
export class PurchaseRequestService {
  private cruiseWrapper: CruiseWrapper = new CruiseWrapper(
    this.cruiseServiceAux.getDefaultCruise()
  );
  private _purchase: Purchase | undefined;
  private _purchaseRequestStatus: PurchaseRequestStatus | undefined;
  private numberOfFormCabinsDivisionFactor = 2;
  private readonly BLOCK_DEPARTURE_RESPONSE_FAILED = 0;
  private readonly UNBLOCK_DEPARTURE_RESPONSE_FAILED = 0;
  private observablePurchase: Observable<Purchase> | undefined;
  private readonly PURCHASE_EXPIRATION_TIME: number;
  private numberRequestAdults: number = 0;
  private numberRequestChildren: number = 0;
  private numberRequestPassengers: number = 0;
  private wasInThakYouPage = false;
  private companyParams: Company | undefined;
  private isHtttpErrorOnHold: boolean = false;
  private isOptionB: boolean = false;
  private transaction: number = 0;
  private packageOption: string = '';
  cabinasItinerarioMenorWrapper: CabinaItinerarioMenorWrapper[] = [];
  private auxCabinsSelected: CabinaItinerarioMenorWrapper[] = [];
  blockCabinRequest: any;
  private MESSAGE_ERROR_GALAVAIL =
    "THIS IS AN AUTOMATIC GENERATED MESSAGE, YOUR ONLINE HOLD COULDN'T GET PROCESSED";
  private MESSAGE_RESERVED_ERROR =
    'THIS IS AN AUTOMATIC GENERATED MESSAGE, THE CABIN IS NO LONGER AVAILABLE';
  public static getPurchaseCabinTypeSummary(): string {
    return '-';
  }

  public static getPurchaseAirTicketDetailsAsArray(
    purchaseAirTicketDetails: PurchaseAirTicketDetail[][]
  ): PurchaseAirTicketDetail[] {
    try {
      const resultPurchaseAirTicketDetailsArray: PurchaseAirTicketDetail[] = [];
      purchaseAirTicketDetails.forEach(
        (purchaseAirTicketDetailsArray: PurchaseAirTicketDetail[]) => {
          purchaseAirTicketDetailsArray.forEach(
            (purchaseAirTicketDetail: PurchaseAirTicketDetail) => {
              resultPurchaseAirTicketDetailsArray.push(purchaseAirTicketDetail);
            }
          );
        }
      );
      return resultPurchaseAirTicketDetailsArray;
    } catch (error) {
      console.log('PurchaseCabinService.getPurchaseAirTicketDetailsAsArray()');
      console.error(error);
      return [];
    }
  }

  public static calculateTotalAirTicketPrice(
    purchaseAirTicketDetails: PurchaseAirTicketDetail[]
  ): number {
    try {
      let totalAirTicketPrice = 0;
      purchaseAirTicketDetails.forEach(
        (purchaseAirTicketDetail: PurchaseAirTicketDetail) => {
          totalAirTicketPrice += purchaseAirTicketDetail.price;
        }
      );
      return totalAirTicketPrice;
    } catch (error) {
      console.log('PurchaseRequestService.calculateTotalAirTicketPrice()');
      console.error(error);
      return 0;
    }
  }

  public static calculateTotalCabinPrice(
    purchaseCabinPassengers: PurchaseCabinPassenger[]
  ): number {
    try {
      let totalPrice = 0;
      purchaseCabinPassengers.forEach(
        (purchaseCabinPassenger: PurchaseCabinPassenger) => {
          totalPrice += purchaseCabinPassenger.price;
        }
      );
      return totalPrice;
    } catch (error) {
      console.log('PurchaseRequestService.calculateTotalCabinPrice()');
      console.error(error);
      throw error;
    }
  }
  public setPercentUsed(selectedPercent: any) {
    if (this.purchase) {
      this.purchase.selectedPercent = selectedPercent;
    }
  }
  public getPercentUsed() {
    if (this.purchase) {
      return this.purchase.selectedPercent;
    }
  }

  setIsSelectedThirtyPerent(value: boolean) {
    if (this.purchase) {
      this.purchase.partialPayment = value;
    }
  }

  setTypeErrorOnHold(value: boolean) {
    this.isHtttpErrorOnHold = value;
  }
  public estimateTotalPrice(
    isOptionB: boolean,
    purchaseCabinPassengers: PurchaseCabinPassenger[],
    includeGalapagosAirTickets: boolean,
    purchaseAirTicketDetails: PurchaseAirTicketDetail[]
  ): number {
    try {
      this.isOptionB = isOptionB;
      let totalPrice: number = PurchaseRequestService.calculateTotalCabinPrice(
        purchaseCabinPassengers
      );
      if (includeGalapagosAirTickets === true && isOptionB) {
        totalPrice += PurchaseRequestService.calculateTotalAirTicketPrice(
          purchaseAirTicketDetails
        );
      }
      return this.purchase?.partialPayment
        ? Math.round(
          totalPrice *
          (this.companyParamsService.getPercentPartialPayment() / 100)
        )
        : totalPrice;
    } catch (error) {
      console.log('PurchaseRequestService.calculatePurchaseTotalPrice()');
      console.error(error);
      throw error;
    }
  }

  private calculatePurchaseTotalPrice(): number | undefined {
    try {
      let purchaseAirTicketDetailsAsArray: PurchaseAirTicketDetail[] = [];
      if (
        this.isIncludeGalapagosAirTickets() &&
        !this.isNullOrUndefined(this.purchase?.purchaseAirTicket)
      ) {
        const valuePurchaveAirticket =
          this.purchase?.purchaseAirTicket?.purchaseAirTicketDetails;
        purchaseAirTicketDetailsAsArray =
          PurchaseRequestService.getPurchaseAirTicketDetailsAsArray(
            valuePurchaveAirticket ? valuePurchaveAirticket : []
          );
      }

      return this.estimateTotalPrice(
        !this.isIncludeAirFare(),
        this.getPurchaseCabinPassengers(),
        this.isIncludeGalapagosAirTickets(),
        purchaseAirTicketDetailsAsArray
      );
    } catch (error) {
      console.log('PurchaseRequestService.calculatePurchaseTotalPrice()');
      console.error(error);
      return undefined;
    }
  }
  setPaymentMethod(paymentMethod: PaymentMethod) {
    if (this.purchase) {
      this.purchase.paymentMethod = paymentMethod;
    }
  }

  setErrorPayment(error: string) {
    if (this.purchase) {
      this.purchase.errorPayment = error;
    }
  }

  getErrorPayment() {
    if (this.purchase) {
      return this.purchase.errorPayment
    }
    return '';
  }

  setCodePaymentMethod(codePaymentMethod: number) {
    if (this.purchase) {
      this.purchase.codePaymenMethod = codePaymentMethod;
    }
  }

  private calculateTotalCabinPrice(): number | undefined {
    try {
      const purchaseCabinPassengers: PurchaseCabinPassenger[] =
        this.getPurchaseCabinPassengers();
      return PurchaseRequestService.calculateTotalCabinPrice(
        purchaseCabinPassengers
      );
    } catch (error) {
      console.log('PurchaseRequestService.calculateTotalCabinPrice()');
      console.error(error);
      return undefined;
    }
  }

  constructor(
    private http: HttpClient,
    private airTicketService: AirTicketService,
    private promoService: PromoService,
    private companyParamsService: CompanyParamsService,
    private httpRequestService: HttpRequestService,
    private cruiseServiceAux: CruiseServiceAux,
    private ngWebflowService: NgWebflowService
  ) {
    this.PURCHASE_EXPIRATION_TIME = environment.PURCHASE.search_expiration_time;
    this.initPurchaseRequest();
  }
  public getPaypalItemsWithThirtyPercent(value: number): PaypalPaymentItem[] {
    try {
      const resultPaypalPaymentItem: PaypalPaymentItem[] = [];
      resultPaypalPaymentItem.push({
        sku: `(${this.createUrlCodeParamForBlockDeparture()})`,
        name: `First Deposit ${this.companyParamsService.getPercentPartialPayment()}% `,
        description: ``,
        quantity: '1',
        price: value,
        currency: environment.PAYPAL_EXPRESS_CHECKOUT_CONFIG.CURRENCY,
      });

      return resultPaypalPaymentItem;
    } catch (error) {
      console.log('PurchaseRequestService.getPaypalItems()');
      console.error(error);
      return [];
    }
  }

  public initPurchaseRequest(): void {
    try {
      this.setPurchase({
        purchaseRequestStatus: PurchaseRequestStatus.INITIAL,
        featureServices: [],
        partialPayment: false,
        paymentMethod: {
          transfer: true,
          creditCard: false,
          paypal: false,
        },
        percentPartialPayment: this.companyParamsService.getPercentPartialPayment(),
        errorPayment: '',
        includes: []
      });
      this.observablePurchase = new Observable((observer) => {
        observer.next(this._purchase!);
      });
    } catch (error) {
      console.log('PurchaseRequestService.initPurchaseRequest()');
      console.error(error);
    }
  }

  public restartPurchaseRequest(): void {
    try {
      this.initPurchaseRequest();
    } catch (error) {
      console.log('PurchaseRequestService.restartPurchaseRequest()');
      console.error(error);
    }
  }

  public getObservablePurchase(): Observable<Purchase> | undefined {
    return this.observablePurchase;
  }

  public getCruiseWrapper(): CruiseWrapper {
    return this.cruiseWrapper;
  }

  public setCruiseWrapper(cruiseWrapper: CruiseWrapper): void {
    this.cruiseWrapper = cruiseWrapper;
  }

  public setNumberRequestAdults(cuantity: number) {
    this.numberRequestAdults = cuantity;
  }

  public getNumberRequestAdults() {
    return this.numberRequestAdults;
  }

  public setNumberRequestChildren(cuantity: number) {
    this.numberRequestChildren = cuantity;
  }

  public getNumberRequestChildren() {
    return this.numberRequestChildren;
  }

  public setNumberRequestPassengers(cuantity: number) {
    this.numberRequestPassengers = cuantity;
  }

  public getNumberRequestPassengers() {
    return this.numberRequestPassengers;
  }

  public addCruise(cruise: Cruise) {
    if (this.purchase) {
      this.purchase.cruise = cruise;
      this.setCruiseWrapper(new CruiseWrapper(this.purchase.cruise));
    }
  }

  get purchase(): Purchase | undefined {
    return this._purchase;
  }

  private setPurchase(purchase: Purchase) {
    this._purchase = purchase;
    if (this.purchase) this.purchase.cabins = [];
  }

  get purchaseRequestStatus(): PurchaseRequestStatus {
    if (this._purchaseRequestStatus) {
      return this._purchaseRequestStatus;
    } else {
      return PurchaseRequestStatus.INITIAL;
    }
  }

  set purchaseRequestStatus(value: PurchaseRequestStatus) {
    this._purchaseRequestStatus = value;
  }

  public addCabins(purchaseCabins: PurchaseCabin[]): void {
    if (this.purchase) this.purchase.cabins = purchaseCabins;
  }

  public addPaymentToPurchaseRequestObject(
    purchasePayment: PurchasePayment
  ): boolean {
    try {
      if (this.purchase) this.purchase.payment = purchasePayment;
      return !this.isNullOrUndefined(this.purchase?.payment);
    } catch (error) {
      console.log('PurchaseRequestService.addPayment()');
      console.error(error);
      return false;
    }
  }

  public addPaymentResponse(
    paymentResponse: any,
    paymentType: PaymentType
  ): boolean {
    try {
      const purchasePayment: PurchasePayment = {
        // tslint:disable-next-line:object-literal-shorthand
        paymentType: paymentType,
        PaypalPaymentReseponse:
          paymentType === PaymentType.PAYPAL
            ? paymentResponse
            : { create_time: paymentResponse.getTransactionTime() },
        paypalPayflowResponse:
          paymentType === PaymentType.payflowCreditCard ? paymentResponse : {},
      };
      this.addPaymentToPurchaseRequestObject(purchasePayment);
      return true;
    } catch (error) {
      console.log('PurchaseRequestService.addPaypalPayment()');
      console.error(error);
      return false;
    }
  }

  /***
   * This is used to determine the maximum number of available cabins that are going to be showon to
   * the user.
   * @returns {number[]} Number of avalilable cabins
   */
  public getNumberOfAvailableCabins(): number {
    return Math.round(
      this.getNumberOfPassengers() / this.numberOfFormCabinsDivisionFactor
    );
  }

  public getNumberOfCabinPassengers(): number {
    try {
      let totalPassengers = 0;
      if (!this.purchase?.cabins) {
        return totalPassengers;
      }
      this.purchase.cabins.forEach(
        (cabin) => (totalPassengers += cabin.adults + cabin.children)
      );
      return totalPassengers;
    } catch (error) {
      console.log('PurchaseRequestService.getNumberOfCabinPassengers()');
      console.error(error);
      return 0;
    }
  }

  public getNumberOfPassengers(): number {
    return (
      (this.numberRequestAdults ? this.numberRequestAdults : 0) +
      (this.numberRequestChildren ? this.numberRequestChildren : 0)
    );
  }

  public getNumberOfAdults(): number | undefined {
    return this.purchase?.adults;
  }

  public getNumberOfChildren(): number | undefined {
    return this.purchase?.children;
  }

  getIsSelectedThirtyPerent(): boolean | undefined {
    return this.purchase?.partialPayment;
  }

  public addPurchasePassengersInformation(
    purchasePassengersInformation: PurchasePassengerInformation[][]
  ): boolean {
    try {
      purchasePassengersInformation.forEach(
        (cabin: PurchasePassengerInformation[], cabinIndex: number) => {
          cabin.forEach(
            (
              purchasePassengerInformation: PurchasePassengerInformation,
              purchasePassengerIndex: number
            ) => {
              if (this.purchase?.cabins) {
                const auxCabins = this.purchase.cabins[cabinIndex];
                auxCabins.purchaseCabinPasssengers[
                  purchasePassengerIndex
                ].purchasePassengerInformation = purchasePassengerInformation;

                this.purchase.cabins[cabinIndex] = auxCabins;
              }
            }
          );
        }
      );
      return true;
    } catch (error) {
      console.log('PurchaseRequestService.addPurchasePassengersInformation()');
      console.error(error);
      return false;
    }
  }
  public addPurchaseContectPerson(
    purchaseContactPerson: PurchaseContactPerson
  ): void {
    if (this.purchase)
      this.purchase.purchaseContactPerson = purchaseContactPerson;
  }

  public addPurchaseContactPerson(
    purchaseContactPerson: PurchaseContactPerson
  ): void {
    if (this.purchase)
      this.purchase.purchaseContactPerson = purchaseContactPerson;
  }

  public getPurchaseCabinTypeSummary(): string {
    const purchaseCabins: PurchaseCabin[] | undefined =
      this.getPurchaseCabins();
    const cabinTypesValues: string[] = [];
    let purchaseCabinTypeSummary = '';

    if (!purchaseCabins || purchaseCabins.length === 0) {
      return '';
    } else if (purchaseCabins.length === 1) {
      return 'a ' + purchaseCabins[0].cabinaItinerarioMenor.type + ' cabin';
    }

    purchaseCabins.forEach((purchaseCabin) => {
      const valueString = purchaseCabin?.cabinaItinerarioMenor?.type;
      cabinTypesValues.push(valueString ? valueString : '');
    });

    let nonRepeateCabinTypesValues: string[] = [];
    // tslint:disable-next-line:only-arrow-functions
    nonRepeateCabinTypesValues = cabinTypesValues.filter(function (
      elem,
      index,
      self
    ) {
      return index === self.indexOf(elem);
    });

    for (let i = 0; i < nonRepeateCabinTypesValues.length; i++) {
      purchaseCabinTypeSummary += nonRepeateCabinTypesValues[i];
      if (i < nonRepeateCabinTypesValues.length - 2) {
        purchaseCabinTypeSummary += ', ';
      } else if (i === nonRepeateCabinTypesValues.length - 2) {
        purchaseCabinTypeSummary += ' and ';
      }
    }
    return purchaseCabinTypeSummary + ' cabins';
  }

  public getPurchaseCabinObjectSummary(): {
    cabinaItinerarioNombre: string;
    camaCabinaNombre: string;
  }[] {
    try {
      const result: {
        cabinaItinerarioNombre: string;
        camaCabinaNombre: string;
      }[] = [];
      this.purchase?.cabins?.forEach((purchaseCabin: PurchaseCabin) => {
        const cabinaItinerarioWrapper: CabinaItinerarioMenorWrapper =
          new CabinaItinerarioMenorWrapper(purchaseCabin.cabinaItinerarioMenor);
        result.push({
          cabinaItinerarioNombre: cabinaItinerarioWrapper.getCabinaFullName(),
          camaCabinaNombre: purchaseCabin.camaCabinaList.description,
        });
      });
      return result;
    } catch (error) {
      console.log('PurchaseRequestService.getPurchaseCabinObjectSummary()');
      console.error(error);
      return [];
    }
  }

  public getPurchaseCabins(): PurchaseCabin[] {
    return this.purchase?.cabins ? this.purchase?.cabins : [];
  }
  public getTotalPriceWithoutDiscount(): number | undefined {
    try {
      if (this.purchase)
        this.purchase.totalPrice =
          this.calculatePurchaseTotalPriceWithoutThirtyPercent();
      return this.purchase?.totalPrice;
    } catch (error) {
      console.log('PurchaseRequestService.getTotalPrice()');
      console.error(error);
      throw new Error();
    }
  }

  private calculatePurchaseTotalPriceWithoutThirtyPercent(): any {
    try {
      let purchaseAirTicketDetailsAsArray: PurchaseAirTicketDetail[] = [];
      if (
        this.isIncludeGalapagosAirTickets() &&
        !this.isNullOrUndefined(this.purchase?.purchaseAirTicket)
      ) {
        const i = this.purchase?.purchaseAirTicket?.purchaseAirTicketDetails;
        purchaseAirTicketDetailsAsArray =
          PurchaseRequestService.getPurchaseAirTicketDetailsAsArray(i ? i : []);
      }

      return this.estimateTotalPriceWithoutThirtyPercent(
        this.getPurchaseCabinPassengers(),
        this.isIncludeGalapagosAirTickets(),
        purchaseAirTicketDetailsAsArray
      );
    } catch (error) {
      console.log('PurchaseRequestService.calculatePurchaseTotalPrice()');
      console.error(error);
    }
  }

  public estimateTotalPriceWithoutThirtyPercent(
    purchaseCabinPassengers: PurchaseCabinPassenger[],
    includeGalapagosAirTickets: boolean,
    purchaseAirTicketDetails: PurchaseAirTicketDetail[]
  ): number {
    try {
      let totalPrice: number = PurchaseRequestService.calculateTotalCabinPrice(
        purchaseCabinPassengers
      );
      if (includeGalapagosAirTickets === true) {
        totalPrice += PurchaseRequestService.calculateTotalAirTicketPrice(
          purchaseAirTicketDetails
        );
      }
      return totalPrice;
    } catch (error) {
      console.log('PurchaseRequestService.calculatePurchaseTotalPrice()');
      console.error(error);
      throw error;
    }
  }

  public setPurchaseTotalPrice(): void {
    if (this.purchase)
      this.purchase.totalPrice = this.calculatePurchaseTotalPrice();
  }

  public getPurchaseTotalPrice(): number | undefined {
    try {
      if (this.purchase)
        this.purchase.totalPrice = this.calculatePurchaseTotalPrice();
      return this.purchase?.totalPrice;
    } catch (error) {
      console.log('PurchaseRequestService.getTotalPrice()');
      console.error(error);
      // tslint:disable-next-line:new-parens
      throw new Error();
    }
  }
  public setAditionalServices(aditionalServices: string[]): void {
    if (this.purchase) this.purchase.aditionalServices = aditionalServices;
  }
  public getAditionalServices(): string[] {
    return this.purchase?.aditionalServices
      ? this.purchase?.aditionalServices
      : [];
  }

  public getTotalCabinPrice(): number {
    try {
      this.setTotalCabinPrice();
      return this.purchase?.totalCabinPrice
        ? this.purchase?.totalCabinPrice
        : 0;
    } catch (error) {
      console.log('PurchaseRequestService.getTotalCabinPrice()');
      return 0;
    }
  }

  public setTotalCabinPrice(): void {
    try {
      if (this.purchase)
        this.purchase.totalCabinPrice = this.calculateTotalCabinPrice();
    } catch (error) {
      console.log('PurchaseRequestService.setTotalCabinPrice()');
      console.error(error);
    }
  }

  public setTrackingCode(bookingTrackCode: string): void {
    if (!this.getBookingTrackCode()) {
      if (this.isNullOrUndefined(bookingTrackCode)) {
        if (this.purchase)
          this.purchase.bookingTrackCode = Math.round(
            Math.random() * 100000000000 + 1
          ).toString();
      } else {
        if (this.purchase) this.purchase.bookingTrackCode = bookingTrackCode;
      }
    }
  }

  public setBlockDeparture(blockDeparture: BlockDeparture): boolean {
    try {
      console.log('setBlocdeparture', blockDeparture);

      if (this.isNullOrUndefined(blockDeparture)) {
        return false;
      }
      if (this.purchase) this.purchase.blockDeparture = blockDeparture;
      return true;
    } catch (error) {
      console.log('PurchaseRequestService.setBlockDeparture');
      console.error(error);
      return false;
    }
  }

  public getBlockDeparture(): BlockDeparture | undefined {
    try {
      return this.purchase?.blockDeparture;
    } catch (error) {
      console.log('PurchaserequestService.getBlockDeparture()');
      console.error(error);
      return undefined;
    }
  }

  public setUnblockDeparture(unblockDeparture: UnblockDeparture): boolean {
    try {
      if (this.isNullOrUndefined(unblockDeparture)) {
        return false;
      }
      if (this.purchase) this.purchase.unblockDeparture = unblockDeparture;
      return true;
    } catch (error) {
      console.log('PurchaseRequestService.setUnblockDeparture');
      console.error(error);
      return false;
    }
  }

  public getUnblockDeparture(): UnblockDeparture | undefined {
    try {
      return this.purchase?.unblockDeparture;
    } catch (error) {
      console.log('PurchaserequestService.getUnblockDeparture()');
      console.error(error);
      return undefined;
    }
  }

  public getBookingTrackCode(): string | undefined {
    return this.purchase?.bookingTrackCode;
  }

  public getPurchasePassengersInformation(): PurchasePassengerInformation[] {
    const passengersInformation: PurchasePassengerInformation[] = [];
    try {
      const purchaseCabinPassengers: PurchaseCabinPassenger[] =
        this.getPurchaseCabinPassengers();
      if (
        this.isNullOrUndefined(purchaseCabinPassengers) ||
        purchaseCabinPassengers.length === 0
      ) {
        return [];
      }
      purchaseCabinPassengers.forEach(
        (purchaseCabinPassenger: PurchaseCabinPassenger) => {
          const purchasePassengerInformation:
            | PurchasePassengerInformation
            | undefined = purchaseCabinPassenger.purchasePassengerInformation;
          if (!this.isNullOrUndefined(purchasePassengerInformation)) {
            if (purchasePassengerInformation)
              passengersInformation.push(purchasePassengerInformation);
          }
        }
      );
      return passengersInformation;
    } catch (error) {
      console.log('PurchaseRequestService.getPassengers()');
      console.error(error);
      return [];
    }
  }

  public getPurchaseContactPerson(): PurchaseContactPerson | undefined {
    return this.purchase?.purchaseContactPerson;
  }

  public getPurchaseCabinPassengers(): PurchaseCabinPassenger[] {
    const purchaseCabinPassengers: PurchaseCabinPassenger[] = [];
    try {
      this.getPurchaseCabins()?.forEach((purchaseCabin: PurchaseCabin) => {
        purchaseCabin.purchaseCabinPasssengers.forEach(
          (purchaseCabinPassenger: PurchaseCabinPassenger) => {
            purchaseCabinPassengers.push(purchaseCabinPassenger);
          }
        );
      });
      return purchaseCabinPassengers;
    } catch (error) {
      console.error(error);
      return [];
    }
  }

  getPaymentMethod(): PaymentMethod | undefined {
    return this.purchase?.paymentMethod;
  }

  public getTotalPrice(): number | undefined {
    try {
      if (this.purchase)
        this.purchase.subTotalPrice = this.calculatePurchaseTotalPrice();
      return this.purchase?.subTotalPrice;
    } catch (error) {
      console.log('PurchaseRequestService.getTotalPrice()');
      console.error(error);
      // tslint:disable-next-line: new-parens
      throw new Error();
    }
  }

  public getPricePerPerson(): number {
    return 0;
  }

  public getPurchaseAdults(): number {
    const adults = this.purchase?.adults;
    return adults ? adults : 0;
  }

  public getPurchaseChildren(): number {
    const value = this.purchase?.children;
    return value ? value : 0;
  }

  public isIncludesFreeTransfers(): boolean {
    const value = this.purchase?.includesFreeTransfers;
    return value ? value : false;
  }

  public isIncludeAirFare(): boolean {
    const value = this.purchase?.includeAirFare;
    return value ? value : false;
  }

  public setIncludeAirFare(includeAirFare: boolean): void {
    if (this.purchase) {
      this.purchase.includeAirFare = includeAirFare;
    }
  }
  public setChildren(children: number): void {
    if (this.purchase) {
      this.purchase.children = children;
    }
  }
  public setAdults(adults: number): void {
    if (this.purchase) {
      this.purchase.adults = adults;
    }
  }
  public setIncludeGalapagosAirTickets(
    includesGalapagosAirTickets: boolean
  ): void {
    if (this.purchase) {
      this.purchase.includesGalapagosAirTickets = includesGalapagosAirTickets;
    }
  }

  public isIncludeGalapagosAirTickets(): boolean {
    try {
      if (this.purchase) {
        const value = this.purchase.includesGalapagosAirTickets;
        return value ? value : false;
      } else {
        return false;
      }
    } catch (error) {
      return false;
    }
  }

  public setPurchaseAirTicket(): void {
    try {
      if (
        this.isNullOrUndefined(this.isIncludeGalapagosAirTickets()) ||
        this.isIncludeGalapagosAirTickets() === false ||
        this.isNullOrUndefined(this.getPurchaseCabins())
      ) {
        if (this.purchase) {
          this.purchase.purchaseAirTicket = undefined;
        }
        return;
      }
      const purchaseAirTicketDetails: PurchaseAirTicketDetail[][] =
        this.createPurchaseAirTicketDetails();
      const purchaseAirTicketDetailsAsArray: PurchaseAirTicketDetail[] =
        PurchaseRequestService.getPurchaseAirTicketDetailsAsArray(
          purchaseAirTicketDetails
        );
      const totalPrice: number =
        PurchaseRequestService.calculateTotalAirTicketPrice(
          purchaseAirTicketDetailsAsArray
        );
      if (purchaseAirTicketDetails.length < 1) {
        if (this.purchase) {
          this.purchase.purchaseAirTicket = undefined;
        }
      }
      if (this.purchase) {
        this.purchase.purchaseAirTicket = {
          purchaseAirTicketDetails,
          totalPurchaseAirTicketPrice: totalPrice,
        };
      }
    } catch (error) {
      console.log('PurchaseRequestService.setPurchaseAirTicket');
      console.error(error);
    }
  }

  private createPurchaseAirTicketDetails(): PurchaseAirTicketDetail[][] {
    try {
      const purchaseAirTicketDetails: PurchaseAirTicketDetail[][] = [];

      this.getPurchaseCabins()?.forEach((purchaseCabin: PurchaseCabin) => {
        const purchaseAirTicketDetailsArray: PurchaseAirTicketDetail[] = [];
        purchaseCabin.purchaseCabinPasssengers.forEach(
          (purchaseCabinPassenger: PurchaseCabinPassenger) => {
            const price = this.airTicketService.getAirTicketPrice(
              purchaseCabinPassenger.type
            );
            // tslint:disable-next-line:object-literal-shorthand
            const purchaseCabinAirTicket: PurchaseAirTicketDetail = {
              price: price,
              type: purchaseCabinPassenger.type,
            };
            purchaseAirTicketDetailsArray.push(purchaseCabinAirTicket);
          }
        );
        purchaseAirTicketDetails.push(purchaseAirTicketDetailsArray);
      });
      return purchaseAirTicketDetails;
    } catch (error) {
      console.log('PurchaseRequestService.createPurchaseAirTicketDetails()');
      console.error(error);
      return [];
    }
  }

  public getPurchaseAirTicket(): PurchaseAirTicket | undefined {
    try {
      return this.purchase?.purchaseAirTicket;
    } catch (error) {
      console.log('PurchaseRequestService.getPurchaseAirTicket()');
      console.error(error);
      return undefined;
    }
  }

  public getCruise(): Cruise {
    const valueCruise = this.purchase?.cruise;
    return valueCruise ? valueCruise : this.cruiseServiceAux.getDefaultCruise();
  }
  // this doesn`t have token
  public requestBookingConfirmation(): Observable<any> {
    try {
      const preparedPurchase =
        this.preparePurchaseObjectToRequestBookingConfirmation();
      // tslint:disable-next-line: deprecation
      const headers = new Headers({});
      // tslint:disable-next-line:object-literal-shorthand
      return this.httpRequestService
        .requestPost(NamesRequestServicesEnum.SEND_INQUIRE_BOOKING_EMAIL, JSON.stringify(preparedPurchase))
        .pipe(
          map((response) => {
            return response.json() as BookingConfirmationResponse;
          })
        );
    } catch (error) {
      console.log('PurchaseRequestService.requestBookingConfirmation()');
      console.error(error);
      // tslint:disable-next-line: deprecation
      return throwError(new Error('' + error));
    }
  }
  // it has token

  public requestbookingInquire(
    automaticNotification?: boolean | false, isPaymentError?: boolean | false
  ): Observable<any> {
    const body = this.preparePurchaseObjectToRequestBookingConfirmation(
      automaticNotification, isPaymentError
    );
    try {
      return this.httpRequestService.requestPost(
        NamesRequestServicesEnum.SEND_INQUIRE_REQUEST_EMAIL,
        JSON.stringify(body)
      );
    } catch (error) {
      if (isDevMode()) {
        console.log('request_bookingConfirm()');
        console.error(error);
      }
      return this.handleError(error);
    }
  }
  getRequestSendConfirmEmail() {
    return this.preparePurchaseBookingConfirm();
  }

  public requestbookingConfirm(wetravelLink?: string): Observable<any> {
    const body = this.preparePurchaseBookingConfirm(wetravelLink);
    try {
      return this.httpRequestService.requestPost(
        NamesRequestServicesEnum.SEND_CONFIRMATION_EMAIL,
        JSON.stringify(body)
      );
    } catch (error) {
      if (isDevMode()) {
        console.log('requestbookingConfirm()');
        console.error(error);
      }
      return this.handleError(error);
    }
  }
  private reduceCruise(preparedPurchaseObject: any): any {
    const cruise: any = {
      name: this.purchase?.cruise?.name,
      type: this.purchase?.cruise?.type,
      image: this.purchase?.cruise?.image,
      departure: this.reduceAvailability(preparedPurchaseObject),
      itinerary: preparedPurchaseObject.cruise.itineraries[0],
      keyFeatures: preparedPurchaseObject.cruise.keyFeatures,
      category: this.purchase?.cruise?.category,
    };
    return cruise;
  }
  private reduceAvailability(preparedPurchaseObject: any): any {
    const availability: any = {
      date: preparedPurchaseObject.cruise.availability[0].date,
      startDate: preparedPurchaseObject.cruise.availability[0].startDate,
      endDate: preparedPurchaseObject.cruise.availability[0].endDate,
      promotion: this.promoService.getPromoText(
        preparedPurchaseObject.cruise.availability[0].promotionType,
        preparedPurchaseObject.cruise.availability[0].promotionValue
      ),
      promotionCode:
        preparedPurchaseObject.cruise.availability[0].promotionCode,
      packageGBCCode: preparedPurchaseObject.cruise.availability[0].packageGBCCode,
      name: preparedPurchaseObject.cruise.availability[0].name,
      length: preparedPurchaseObject.cruise.availability[0].length,
    };
    return availability;
  }
  private reduceCabin(cabins: any): any {
    const res: any[] = [];
    Object(cabins).forEach((item: any) => {
      const cabin: any = item;
      const toAdd: any = {
        adults: cabin.adults,
        children: cabin.children,
        deck: cabin.cabinaItinerarioMenor.deck,
        type: cabin.cabinaItinerarioMenor.type,
        acommodation: cabin.camaCabinaList.description,
        purchaseCabinPassengers: cabin.purchaseCabinPasssengers,
      };
      res.push(toAdd);
    });
    return res;
  }

  public preparePurchaseBookingConfirm(wetravelLink?: string): any {
    try {
      const preparedPurchaseObject: any = JSON.parse(
        JSON.stringify(this.purchase),
      );
      preparedPurchaseObject.cruise.availability =
        preparedPurchaseObject.cruise.availability.filter(
          (availability: any, index: number) => {
            return index === preparedPurchaseObject.cruise.iterIndex;
          }
        );

      // setted itineraries selected
      const nameItinerarie =
        preparedPurchaseObject.cruise.availability[0].itinerary;

      preparedPurchaseObject.cruise.itineraries =
        preparedPurchaseObject.cruise.itineraries.filter(
          (itineraries: any, index: number) => {
            return nameItinerarie === itineraries.code;
          }
        );

      const promoId: number =
        preparedPurchaseObject.cruise.availability[0].promotionCode;

      if (promoId === PromoCode.PROMO_NET) {
        const valorEtiquetaPromo: string | null =
          this.promoService.getPromoText(promoId);
        preparedPurchaseObject.cruise.availability[0].promotion =
          valorEtiquetaPromo;
      }

      if (
        preparedPurchaseObject.includesGalapagosAirTickets === false &&
        this.isNullOrUndefined(preparedPurchaseObject.purchaseAirTicket)
      ) {
        preparedPurchaseObject.purchaseAirTicket = {
          totalPurchaseAirTicketPrice: 0,
        };
      }

      let includesArray: any[] = [];
      let featureServices = preparedPurchaseObject.cruise.availability[0]?.featureServices;
      featureServices.forEach((item: any) => {
        if (item.value) {
          includesArray.push(item.name);
        }
      });

      const stars = preparedPurchaseObject.cruise.categoryII as string;
      preparedPurchaseObject.cruise.categoryII = stars.lastIndexOf('★') + 1;
      const valueAirTickets = this.purchase?.purchaseAirTicket
        ? this.purchase.purchaseAirTicket.totalPurchaseAirTicketPrice
        : 0;
      const mynewobjecJson: any = {
        cruise: this.reduceCruise(preparedPurchaseObject),
        includeAirFare: preparedPurchaseObject.includeAirFare,
        includesFreeTransfers: preparedPurchaseObject.includesFreeTransfers,
        includesGalapagosAirTickets:
          preparedPurchaseObject.includesGalapagosAirTickets,
        totalCabinPrice: preparedPurchaseObject.totalCabinPrice,
        totalPrice: preparedPurchaseObject.totalPrice,
        subTotal: preparedPurchaseObject.subTotalPrice,
        partialPayment: preparedPurchaseObject.partialPayment,
        codePaymenMethod: preparedPurchaseObject.codePaymenMethod,
        errorPayment: preparedPurchaseObject.errorPayment === '' ? null : preparedPurchaseObject.errorPayment,
        cabins: this.reduceCabin(preparedPurchaseObject.cabins),
        purchaseContactPerson: preparedPurchaseObject.purchaseContactPerson,
        reference: this.createUrlCodeParamForBlockDeparture(),
        totalAirTickets: valueAirTickets,
        aditionalServices: this.isNullOrUndefined(
          preparedPurchaseObject.aditionalServices,
        )
          ? []
          : preparedPurchaseObject.aditionalServices,
        featureServices: this.isNullOrUndefined(
          preparedPurchaseObject.featureServices
        )
          ? []
          : preparedPurchaseObject.featureServices,
        keyCompany: this.companyParamsService.keyCompany,
        company: this.setCompanyparams(),
        includes: includesArray,
        wetravelLinkPayment: wetravelLink
      };
      return mynewobjecJson;
    } catch (error) {
      console.log(
        'PurchaseRequestService.preparePurchaseObjectToRequestBookingConfirmation()'
      );
      console.error(error);
      return null;
    }
  }

  public preparePurchaseObjectToRequestBookingConfirmation(
    automaticNotification?: boolean | false, paymentErrorNotification?: boolean | false
  ): any {
    try {
      const preparedPurchaseObject: any = JSON.parse(
        JSON.stringify(this.purchase)
      );
      preparedPurchaseObject.cruise.availability =
        preparedPurchaseObject.cruise.availability.filter(
          (availability: any, index: number) => {
            return index === preparedPurchaseObject.cruise.iterIndex;
          }
        );

      // setted itineraries selected
      const nameItinerarie =
        preparedPurchaseObject.cruise.availability[0].itinerary;

      preparedPurchaseObject.cruise.itineraries =
        preparedPurchaseObject.cruise.itineraries.filter(
          (itineraries: any, index: number) => {
            return nameItinerarie === itineraries.code;
          }
        );

      const promoId: number =
        preparedPurchaseObject.cruise.availability[0].promotionCode;

      if (promoId === PromoCode.PROMO_NET) {
        const valorEtiquetaPromo: string | null =
          this.promoService.getPromoText(promoId);
        preparedPurchaseObject.cruise.availability[0].promotion =
          valorEtiquetaPromo;
      }

      if (
        preparedPurchaseObject.includesGalapagosAirTickets === false &&
        this.isNullOrUndefined(preparedPurchaseObject.purchaseAirTicket)
      ) {
        preparedPurchaseObject.purchaseAirTicket = {
          totalPurchaseAirTicketPrice: 0,
        };
      }

      let includesArray: any[] = [];
      let featureServices = preparedPurchaseObject.cruise.availability[0]?.featureServices;
      featureServices.forEach((item: any) => {
        if (item.value) {
          includesArray.push(item.name);
        }
      });

      const stars = preparedPurchaseObject.cruise.categoryII as string;
      preparedPurchaseObject.cruise.categoryII = stars.lastIndexOf('★') + 1;
      const valueAirTickets = this.purchase?.purchaseAirTicket
        ? this.purchase.purchaseAirTicket.totalPurchaseAirTicketPrice
        : 0;
      const mynewobjecJson: any = {
        cruise: this.reduceCruise(preparedPurchaseObject),
        includeAirFare: preparedPurchaseObject.includeAirFare,
        includesFreeTransfers: preparedPurchaseObject.includesFreeTransfers,
        includesGalapagosAirTickets:
          preparedPurchaseObject.includesGalapagosAirTickets,
        totalCabinPrice: preparedPurchaseObject.totalCabinPrice,
        totalPrice: preparedPurchaseObject.totalPrice,
        codePaymenMethod: preparedPurchaseObject.codePaymenMethod,
        errorPayment: preparedPurchaseObject.errorPayment === '' ? null : preparedPurchaseObject.errorPayment,
        cabins: this.reduceCabin(preparedPurchaseObject.cabins),
        purchaseContactPerson: preparedPurchaseObject.purchaseContactPerson,
        reference: this.createUrlCodeParamForBlockDeparture(),
        totalAirTickets: valueAirTickets,
        company: this.setCompanyparams(),
        transaction: paymentErrorNotification === false ? this.getTransactionDetails(automaticNotification || false) : null, // si es null debe tonar el valor de error payment en la notificacion
        emailReceptor: this.companyParamsService.company.emailEcommerce,
        aditionalServices: this.isNullOrUndefined(
          preparedPurchaseObject.aditionalServices
        )
          ? []
          : preparedPurchaseObject.aditionalServices,
        includes: includesArray
      };
      return mynewobjecJson;
    } catch (error) {
      console.log(
        'PurchaseRequestService.preparePurchaseObjectToRequestBookingConfirmation()'
      );
      console.error(error);
      return null;
    }
  }

  getTransactionDetails(automaticNotification: boolean) {
    return {
      id: this.ngWebflowService.objectPersistenceId,
      status: automaticNotification
        ? StatusRequest.FAILED
        : StatusRequest.SUCCESS,
      message: automaticNotification ? this.getCommentError() : '',
    };
  }

  getCommentError(): string {
    return this.isHtttpErrorOnHold
      ? this.MESSAGE_ERROR_GALAVAIL
      : this.MESSAGE_RESERVED_ERROR;
  }

  setCompanyparams(): any {
    try {
      this.companyParams = this.companyParamsService.getCompanyParams();
      if (this.companyParams)
        return {
          logoCompany: this.companyParams.logo,
          nameCompany: this.companyParams.nameRequest,
          fullNameCompany: this.companyParams.name,
          mainColorCompany: this.companyParams.mainColor,
          secondaryColorCompany: this.companyParams.secondaryColor,
          headerColorCompany: this.companyParams.headerColor,
          footerColorCompany: this.companyParams.footerColor,
          infoMailCompany: this.companyParams.infoEmail,
          phoneCompany: this.companyParams.phone,
          webSiteCompany: this.companyParams.webSite,
        };
    } catch (error) {
      return '';
    }
  }
  public setAuxCabinsSelected(cabinsSelected: CabinaItinerarioMenorWrapper[]) {
    this.auxCabinsSelected = cabinsSelected;
  }
  public getAuxCabinsSelected() {
    return this.auxCabinsSelected;
  }
  public isRequestBookingConfirmationSuccess(
    bookingConfirmationResponse: BookingConfirmationResponse
  ): boolean {
    try {
      if (this.isNullOrUndefined(bookingConfirmationResponse)) {
        return false;
      }
      return bookingConfirmationResponse.status;
    } catch (error) {
      console.log(
        'PurchaseRequestService.isRequestBookingConfirmationSuccess()'
      );
      console.error(error);
      return false;
    }
  }

  public requestSaveToDatabase(): void {
    try {
      const databaseTableName: string =
        environment.firebase_table_names.purchase_requests;
      // this.firebaseService.pushWithCustomKey(databaseTableName, this.purchase, this.getBookingTrackCode());
    } catch (error) {
      console.log('PurchaseRequestService.requestSaveToDatabase()');
      console.error(error);
    }
  }

  public requestUnblockDeparture(): Observable<UnblockDeparture> {
    try {
      if (this.isRequestBlockDepartureSuccess() === false) {
        throwError(new Error(''));
      }
      const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
      const purchaseId = this.getBlockDeparture()?.pedido;
      return this.httpRequestService.requestPost(
        'request_unblock_departure',
        purchaseId?.toString()
      );
    } catch (error) {
      return this.galavailRequestsHandler(error);
    }
  }

  public requestBlockDeparture(): Observable<BlockDeparture> {
    try {
      const urlParams = this.createUrlParamsForBlockDeparture();
      // tslint:disable-next-line: new-parens
      if (this.isNullOrUndefined(urlParams)) {
        throw new Error();
      }
      return this.httpRequestService.requestPost(NamesRequestServicesEnum.ON_HOLD, urlParams);
    } catch (error) {
      return this.galavailRequestsHandler(error);
    }
  }
  private handleError(error: any): Observable<any> {
    console.error('purchase-requestservice-> HandleError');
    console.error(error);
    console.log('completed');
    return throwError(new Error(error));
  }
  setBlockCabinRequest(request: any) {
    this.blockCabinRequest = request;
  }
  getBlockCabinRequest() {
    return this.blockCabinRequest;
  }
  setRequestBlockCabinOnHold(agencyPercentObj: any) {
    const codeUser = this.cruiseWrapper?.getCruise().userCode;
    const body = this.jsonblockPurchaseCabin(codeUser, agencyPercentObj);

    this.setBlockCabinRequest(body);
  }
  public requestBlockCabinOnHold(
    agencyPercentObj: any
  ): Observable<BlockDeparture> {
    this.setRequestBlockCabinOnHold(agencyPercentObj);
    const body = this.getBlockCabinRequest();

    try {
      return this.httpRequestService.requestPost(NamesRequestServicesEnum.ON_HOLD, body).pipe(
        map((response) => {
          return response;
        })
      );
    } catch (error) {
      if (isDevMode()) {
        console.log('BarcoService.getAllcruises()');
        console.error(error);
      }
      return this.handleError(error);
    }
  }

  public requestStatusAvailability(
    agencyPercentObj: any
  ): Observable<BlockDeparture> {
    this.setRequestBlockCabinOnHold(agencyPercentObj);
    const body = this.getBlockCabinRequest();

    try {
      return this.httpRequestService.requestPost(NamesRequestServicesEnum.ESTATUS_ON_HOLD, body).pipe(
        map((response) => {
          return response;
        })
      );
    } catch (error) {
      if (isDevMode()) {
        console.log('BarcoService.statuson hol');
        console.error(error);
      }
      return this.handleError(error);
    }
  }

  private galavailRequestsHandler(error: any) {
    if (isDevMode()) {
      console.log('PurchaseRequest.galavailRequestsHandler()');
      console.error(error);
    }
    return throwError(new Error(error));
  }

  public isRequestBlockDepartureSuccess(): boolean {
    try {
      const blockDepartureResponse: BlockDeparture | undefined =
        this.getBlockDeparture();
      return !(
        this.isNullOrUndefined(blockDepartureResponse) ||
        blockDepartureResponse?.status === false ||
        blockDepartureResponse?.pedido === this.BLOCK_DEPARTURE_RESPONSE_FAILED
      );
    } catch (error) {
      console.log('PurchaseRequestService.isRequestBlockDepartureSuccess()');
      console.error(error);
      return false;
    }
  }

  public isRequestUnblockDepartureSuccess(): boolean {
    try {
      const unblockDepartureResponse: UnblockDeparture | undefined =
        this.getUnblockDeparture();
      return !(
        this.isNullOrUndefined(unblockDepartureResponse) ||
        unblockDepartureResponse?.status === false ||
        unblockDepartureResponse?.pedido ===
        this.UNBLOCK_DEPARTURE_RESPONSE_FAILED
      );
    } catch (error) {
      console.log('PurchaseRequestService.isRequestUnblockDepartureSuccess()');
      console.error(error);
      return false;
    }
  }

  private createUrlParamsForBlockDeparture(): string {
    try {
      const currentCruise: CruiseWrapper | undefined = this.getCruiseWrapper();
      let urlParamsAsArray: string[] = [];
      urlParamsAsArray.push(this.createUrlCabinsParamsForBlockDeparture());
      if (currentCruise)
        urlParamsAsArray.push(
          currentCruise
            .getCruise()
            .availability[
            currentCruise.getCurrentItineraryIndex()
          ].code.toString()
        );
      if (currentCruise)
        urlParamsAsArray.push(currentCruise.getCruise().code.toString());
      urlParamsAsArray.push(this.createUrlCodeParamForBlockDeparture());
      urlParamsAsArray = urlParamsAsArray.map((urlParamElement) => {
        if (this.isNullOrUndefined(urlParamElement)) {
          throw new Error();
        }
        return encodeURI(urlParamElement);
      });
      return urlParamsAsArray.join('/');
    } catch (error) {
      console.log('BlockDepartureService.createUrl()');
      console.error(error);
      return '';
    }
  }
  public jsonblockPurchaseCabin(code: any, percent: any): any {
    const purchaseCabins: PurchaseCabin[] | undefined =
      this.getPurchaseCabins();
    const currentCruise: CruiseWrapper | undefined = this.getCruiseWrapper();
    const paramMapArray: any = [];
    purchaseCabins?.forEach((purchaseCabin) => {
      if (
        this.isNullOrUndefined(purchaseCabin.cabinaItinerarioMenor) ||
        this.isNullOrUndefined(purchaseCabin.cabinaItinerarioMenor.code) ||
        this.isNullOrUndefined(purchaseCabin.adults) ||
        this.isNullOrUndefined(purchaseCabin.children) ||
        this.isNullOrUndefined(purchaseCabin.camaCabinaList) ||
        this.isNullOrUndefined(purchaseCabin.camaCabinaList.code)
      ) {
        throw new Error();
      }
      const cabinFormValuesArray: any = {
        departure: purchaseCabin.cabinaItinerarioMenor.code.toString(),
        adults: purchaseCabin.adults.toString(),
        children: purchaseCabin.children.toString(),
        acomodation: purchaseCabin.camaCabinaList.code.toString(),
      };
      paramMapArray.push(cabinFormValuesArray);
    });
    if (currentCruise)
      return {
        reference: this.createUrlCodeParamForBlockDeparture(),
        itinerary: currentCruise
          .getCruise()
          .availability[
          currentCruise.getCurrentItineraryIndex()
        ].code.toString(),
        boat: currentCruise.getCruise().code.toString(),
        cabins: paramMapArray,
        code,
        percent,
        transaction: this.getValueTransaction()
      };
  }
  getValueTransaction() {
    return this.transaction
  }

  setValueTransaction(value: number) {
    this.transaction = value;
  }

  private createUrlCabinsParamsForBlockDeparture(): string {
    try {
      const purchaseCabins: PurchaseCabin[] | undefined =
        this.getPurchaseCabins();
      let urlCabinsParam = '';
      const paramMapArray: string[][] = [];

      if (
        this.isNullOrUndefined(purchaseCabins) ||
        purchaseCabins?.length === 0
      ) {
        return '';
      }
      purchaseCabins?.forEach((purchaseCabin) => {
        if (
          this.isNullOrUndefined(purchaseCabin.cabinaItinerarioMenor) ||
          this.isNullOrUndefined(purchaseCabin.cabinaItinerarioMenor.code) ||
          this.isNullOrUndefined(purchaseCabin.adults) ||
          this.isNullOrUndefined(purchaseCabin.children) ||
          this.isNullOrUndefined(purchaseCabin.camaCabinaList) ||
          this.isNullOrUndefined(purchaseCabin.camaCabinaList.code)
        ) {
          throw new Error();
        }
        const cabinFormValuesArray: string[] = [];
        cabinFormValuesArray.push(
          purchaseCabin.cabinaItinerarioMenor.code.toString()
        );
        cabinFormValuesArray.push(purchaseCabin.adults.toString());
        cabinFormValuesArray.push(purchaseCabin.children.toString());
        cabinFormValuesArray.push(purchaseCabin.camaCabinaList.code.toString());
        paramMapArray.push(cabinFormValuesArray);
      });

      paramMapArray.forEach((cabinFormValuesArray: string[]) => {
        cabinFormValuesArray.forEach((cabinFormValue: string) => {
          urlCabinsParam += cabinFormValue + ',';
        });
        urlCabinsParam += '@';
      });
      return urlCabinsParam;
    } catch (error) {
      console.log('PurchaseRequest.createUrlCabinsParams()');
      console.error(error);
      return '';
    }
  }

  public getPurchaseDescription(): string {
    try {
      return (
        this.getCruiseWrapper()?.getCruiseItineraryDuration() +
        ' Galapagos cruise on the ' +
        this.getCruiseWrapper()?.getLongName() +
        ' on ' +
        this.getPurchaseCabinTypeSummary() +
        ', for ' +
        this.getNumberOfPassengers() +
        ' passenger'
      );
    } catch (error) {
      console.log('PurchaseRequestService.getPurchaseDescription()');
      console.error(error);
      return '';
    }
  }

  public getPurchaseShortDescription(): string {
    try {
      return (
        this.getCruiseWrapper()?.getCruiseItineraryDuration() +
        ' Galapagos cruise on the ' +
        this.getCruiseWrapper()?.getLongName()
      );
    } catch (error) {
      console.log('PurchaseRequestService.getPurchaseShortDescription()');
      console.error(error);
      return '';
    }
  }

  public getPurchaseDescriptor(): string {
    try {
      const itineraryDuration =
        this.getCruiseWrapper()?.getCruiseItineraryDuration();
      const cruiseName = this.getCruiseWrapper()?.getLongName();
      const itineraryDepartureTime =
        this.getCruiseWrapper()?.getItineraryDepartureTime();
      const itineraryId: number =
        this.getCruiseWrapper()?.getCurrentItinerary().codigo;

      return (
        itineraryDuration +
        '_' +
        cruiseName?.replace(' ', '-') +
        '_' +
        itineraryDepartureTime?.toDateString().replace(' ', '-') +
        '_' +
        itineraryId
      );
    } catch (error) {
      console.log('PurchaseRequestService.getPurchaseDescriptor()');
      console.error(error);
      return '';
    }
  }

  private createUrlCodeParamForBlockDeparture(): string {
    try {
      const separator = 'X';
      const valuePurchase = this.getPurchaseContactPerson();
      const purchaseContactPersonCompleteName = valuePurchase
        ? valuePurchase.firstName + valuePurchase.lastName
        : '';
      const purchaseTotalPassengers = this.getNumberOfPassengers();
      if (
        this.isNullOrUndefined(purchaseContactPersonCompleteName) ||
        this.isNullOrUndefined(purchaseTotalPassengers)
      ) {
        return '';
      }
      return (
        purchaseContactPersonCompleteName + separator + purchaseTotalPassengers
      );
    } catch (error) {
      console.log('BlockDepartureService.createUrlCodeParam()');
      console.error(error);
      return '';
    }
  }

  public getCabinAndBedDescriptionsSummary(): string[] {
    try {
      if (
        this.purchase &&
        this.purchase.cabins &&
        this.purchase.cabins.length < 1
      ) {
        return [];
      }
      const cabinAndBedDescriptionsSummary: string[] = [];
      this.purchase?.cabins?.forEach((purchaseCabin: PurchaseCabin) => {
        const cabinaItinerarioWrapper: CabinaItinerarioMenorWrapper =
          new CabinaItinerarioMenorWrapper(purchaseCabin.cabinaItinerarioMenor);
        const text =
          cabinaItinerarioWrapper.getCabinaFullName() +
          ' - ' +
          purchaseCabin.camaCabinaList.cama.nombre;
        cabinAndBedDescriptionsSummary.push(text);
      });
      return cabinAndBedDescriptionsSummary;
    } catch (error) {
      console.log('PurchaseRequestService.getCabinAndBedDescriptionsSummary()');
      console.error(error);
      return [];
    }
  }

  public isAutoPaymentAccepted(): boolean {
    try {
      return environment.PURCHASE.IS_AUTO_PAYMENT_ACCEPTED;
    } catch (error) {
      console.log('PurchaseRequiestService.isAlmostDepartureTime()');
      console.error(error);
      return false;
    }
  }

  public setPrices(): void {
    this.setPurchaseAirTicket();
    this.setTotalCabinPrice();
    this.setPurchaseTotalPrice();
  }

  public validatePurchaseRequest(): boolean {
    try {
      return true; // TODO implementar este método para validar todos y cada uno de los datos susceptibles antes de confirmar compra
    } catch (error) {
      console.log('PurchaseCabinRequest.validatePurchaseRequest()');
      console.error(error);
      return false;
    }
  }

  public executePurchase(): boolean {
    try {
      return this.validatePurchaseRequest();
    } catch (error) {
      console.log('PurchaseCabinRequest.executePurchase()');
      console.error(error);
      return false;
    }
  }

  public getPaypalItems(): PaypalPaymentItem[] {
    try {
      const resultPaypalPaymentItem: PaypalPaymentItem[] = [];
      let sku: string;
      let name: string;
      let description: string;
      sku = '';
      name = '';
      description = '';
      const cabinOrdinalNamePipe = new CabinOrdinalNamePipe();
      this.getPurchaseCabins()?.forEach((purchaseCabin, index) => {
        const cabinaItinerarioWrapper: CabinaItinerarioMenorWrapper =
          new CabinaItinerarioMenorWrapper(purchaseCabin.cabinaItinerarioMenor);
        console.log('cabinaItinerarioWrapper', cabinaItinerarioWrapper);
        description =
          description.length > 990
            ? description + '...'
            : description +
            ' ' +
            cabinOrdinalNamePipe.transform(index + 1) +
            ': ' +
            cabinaItinerarioWrapper.getCabinaFullName() +
            '.';
      });
      const valuePrice = this.getTotalPrice();
      resultPaypalPaymentItem.push({
        sku: ' Cabins',
        name: 'Purchase',
        description,
        quantity: '1',
        price: valuePrice ? valuePrice : 0,
        currency: environment.PAYPAL_EXPRESS_CHECKOUT_CONFIG.CURRENCY,
      });
      /* this.getPurchaseAirTicket().purchaseAirTicketDetails.forEach(
        ( purchaseAirTickedDetailArray: PurchaseAirTicketDetail[] ) => {
          purchaseAirTickedDetailArray.forEach( ( purchaseAirTickedDetail: PurchaseAirTicketDetail ) => {
            resultPaypalPaymentItem.push( {
              sku: 'GALAPAGOS_AIR_TICKET',
              name: 'Purchase Air Ticket for ' + purchaseAirTickedDetail.type,
              description: '',
              quantity: '1',
              price: purchaseAirTickedDetail.price,
              currency: environment.PAYPAL_EXPRESS_CHECKOUT_CONFIG.CURRENCY
            } );
          } );
      } );*/
      return resultPaypalPaymentItem;
    } catch (error) {
      console.log('PurchaseRequestService.getPaypalItems()');
      console.error(error);
      return [];
    }
  }

  public getPaypalItemsApi(): PaypalPaymentItemApi[] {
    try {
      const resultPaypalPaymentItem: PaypalPaymentItemApi[] = [];
      let category: string;
      let name: string;
      let description: string;
      category = '';
      name = '';
      description = '';
      const cabinOrdinalNamePipe = new CabinOrdinalNamePipe();
      this.getPurchaseCabins()?.forEach((purchaseCabin, index) => {
        const cabinaItinerarioWrapper: CabinaItinerarioMenorWrapper =
          new CabinaItinerarioMenorWrapper(purchaseCabin.cabinaItinerarioMenor);
        description =
          description.length > 990
            ? description + '...'
            : description +
            ' ' +
            cabinOrdinalNamePipe.transform(index + 1) +
            ': ' +
            cabinaItinerarioWrapper.getCabinaFullName() +
            '.';
      });
      const valuePrice = this.getTotalPrice()?.toString();
      const unit_amount = {
        currency_code: environment.PAYPAL_EXPRESS_CHECKOUT_CONFIG.CURRENCY,
        value: valuePrice ? valuePrice : '0',
      };
      resultPaypalPaymentItem.push({
        name: `TA by (${this.createUrlCodeParamForBlockDeparture()})`,
        quantity: '1',
        category: 'DIGITAL_GOODS',
        description: `Total Amount 100% by (${this.createUrlCodeParamForBlockDeparture()})`,
        unit_amount,
      });

      return resultPaypalPaymentItem;
    } catch (error) {
      console.log('PurchaseRequestService.getPaypalItems()');
      console.error(error);
      return [];
    }
  }

  public getPaypalItemsApiWithThirtyPercent(
    value: number
  ): PaypalPaymentItemApi[] {
    try {
      const resultPaypalPaymentItem: PaypalPaymentItemApi[] = [];
      const unit_amount = {
        currency_code: environment.PAYPAL_EXPRESS_CHECKOUT_CONFIG.CURRENCY,
        value: value.toString(),
      };
      resultPaypalPaymentItem.push({
        category: `DIGITAL_GOODS`,
        name: `FD ${this.companyParamsService.getPercentPartialPayment()}% by (${this.createUrlCodeParamForBlockDeparture()})`,
        quantity: '1',
        description : `First Deposit ${this.companyParamsService.getPercentPartialPayment()}% by (${this.createUrlCodeParamForBlockDeparture()})`,
        unit_amount,
      });

      return resultPaypalPaymentItem;
    } catch (error) {
      console.log('PurchaseRequestService.getPaypalItems()');
      console.error(error);
      return [];
    }
  }
  private getTipoPaqueteEcommerce(): any {
    try {
      const cruiseWrepper: CruiseWrapper | undefined = this.getCruiseWrapper();
      if (
        !this.isNullOrUndefined(cruiseWrepper) &&
        !this.isNullOrUndefined(cruiseWrepper?.getTipoPaqueteEcommerce())
      ) {
        return this.getCruiseWrapper()?.getTipoPaqueteEcommerce();
      }
    } catch (error) {
      console.log('PurchaseRequestService.getTipoPaqueteEcommerce()');
      console.error(error);
    }
    return 0;
  }

  public isOptionAAvailable(): boolean {
    try {
      const tipoPaqueteEcommerce: number = this.getTipoPaqueteEcommerce();
      if (
        !this.isNullOrUndefined(tipoPaqueteEcommerce) &&
        !this.isNullOrUndefined(tipoPaqueteEcommerce) &&
        (tipoPaqueteEcommerce === TipoPaqueteEcommerceEnum.TYPE_A ||
          tipoPaqueteEcommerce === TipoPaqueteEcommerceEnum.TYPE_A_B)
      ) {
        return true;
      }
    } catch (error) {
      console.log('PurchaseRequest.isOptionAAvailable()');
      console.error(error);
    }
    return false;
  }

  public isOptionBAvailable(): boolean {
    try {
      const tipoPaqueteEcommerce: number = this.getTipoPaqueteEcommerce();
      if (
        !this.isNullOrUndefined(tipoPaqueteEcommerce) &&
        !this.isNullOrUndefined(tipoPaqueteEcommerce) &&
        (tipoPaqueteEcommerce === TipoPaqueteEcommerceEnum.TYPE_B ||
          tipoPaqueteEcommerce === TipoPaqueteEcommerceEnum.TYPE_A_B)
      ) {
        return true;
      }
    } catch (error) {
      console.log('PurchaseRequest.isOptionBAvailable()');
      console.error(error);
    }
    return false;
  }
  setAllCabins(cabins: CabinaItinerarioMenorWrapper[]) {
    this.cabinasItinerarioMenorWrapper = cabins;
  }
  getAllCabins() {
    return this.cabinasItinerarioMenorWrapper;
  }
  public isPackageOption(tipoPaqueteEcommerce: number): boolean {
    try {
      return (
        !this.isNullOrUndefined(this.getTipoPaqueteEcommerce()) &&
        Number(this.getTipoPaqueteEcommerce()) === Number(tipoPaqueteEcommerce)
      );
    } catch (error) {
      console.log('PurchaseRequestService.isPackageOption()');
      console.error(error);
    }
    return false;
  }
  setWasInThakYouPage(data: boolean) {
    this.wasInThakYouPage = data;
  }
  getWasInThakYouPage(): boolean {
    return this.wasInThakYouPage;
  }

  isNullOrUndefined(value: any) {
    return value === null || value === undefined;
  }
  public setFeatureServices(featureServices: any[]): void {
    if (this.purchase) this.purchase.featureServices = featureServices;
  }

  getDescriptionStripe() {
    return this.createUrlCodeParamForBlockDeparture();
  }

  setPackageOption(packageOption: string) {
    this.packageOption = packageOption;
  }

  getPackageOption(): string {
    return this.packageOption;
  }

  getNoteSquare(): string {
    return this.createUrlCodeParamForBlockDeparture();
  }

  getDepartureDate(): Date | undefined {
    try {
      const cruiseWrapper: CruiseWrapper | undefined = this.getCruiseWrapper();
      if (cruiseWrapper) {
        const availability: any =
          cruiseWrapper.getCruise().availability[
            cruiseWrapper.getCurrentItineraryIndex()
          ];
        if (availability && availability.startDate) {
          // Convertimos el valor a Date por si viene como String desde la API
          return new Date(availability.startDate);
        }
      }
    } catch (error) {
      console.log('PurchaseRequestService.getDepartureDate()');
      console.error(error);
    }
    return undefined;
  }

  /**
   * Guarda el estado actual del purchase en sessionStorage antes de redirigir a procesador de pagos
   */
  public savePurchaseToSession(): void {
    try {
      if (typeof sessionStorage === 'undefined') { return; }
      const purchaseData = JSON.stringify(this._purchase);
      sessionStorage.setItem('purchaseData', purchaseData);
    } catch (error) {
      console.error('Error saving purchase to session:', error);
    }
  }

  /**
   * Restaura el purchase desde sessionStorage cuando se regresa del procesador de pagos
   * @returns true si se restauró correctamente, false si no hay datos
   */
  public restorePurchaseFromSession(): boolean {
    try {
      if (typeof sessionStorage === 'undefined') { return false; }
      const purchaseData = sessionStorage.getItem('purchaseData');
      if (purchaseData) {
        this._purchase = JSON.parse(purchaseData);
        if (this._purchase && this._purchase.cruise) {
          this.setCruiseWrapper(new CruiseWrapper(this._purchase.cruise));
          return true;
        }
      }
      return false;
    } catch (error) {
      console.error('Error restoring purchase from session:', error);
      return false;
    }
  }

  /**
   * Limpia los datos de purchase guardados en sessionStorage
   */
  public clearPurchaseSession(): void {
    try {
      if (typeof sessionStorage === 'undefined') { return; }
      sessionStorage.removeItem('purchaseData');
    } catch (error) {
      console.error('Error clearing purchase session:', error);
    }
  }

  getReference() {
    return this.createUrlCodeParamForBlockDeparture().slice(0, 19);
  }

  /**
   * Genera una referencia única para el pago
   */
  generatePaymentReference(): string {
    const reference = this.getReference();
    const timestamp = Date.now();
    const referenceWithTimestamp = `${reference}-${timestamp}`;
    return referenceWithTimestamp.slice(0, 32); // Limitar a 32 caracteres
  }
}
